import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'kudos_v2',
  size: 'full',
} as const satisfies Location
